(() => {
  'use strict';

  const timers = new WeakMap();

  function firstMediaUrl(root) {
    try {
      const media = JSON.parse(root.querySelector('[data-lite-media]')?.textContent || '[]');
      if (!Array.isArray(media)) return '';
      const first = media.find((item) => item?.url || item?.image);
      return String(first?.url || first?.image || '');
    } catch (error) {
      console.warn('MASONTEX product media fallback error', error);
      return '';
    }
  }

  function seedFirstImage(root) {
    const image = root.querySelector('[data-lite-image-a]');
    if (!image || image.getAttribute('src')) return false;

    const url = firstMediaUrl(root);
    if (!url) return false;

    image.src = url;
    image.classList.add('is-active');
    return true;
  }

  function hide(root) {
    root.querySelector('[data-lite-loading]')?.classList.add('is-hidden');
    const timer = timers.get(root);
    if (timer) clearTimeout(timer);
    timers.delete(root);
  }

  function settle(root) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => hide(root));
    });
  }

  function arm(root) {
    if (!root) return;
    const loader = root.querySelector('[data-lite-loading]');
    if (!loader) return;

    const previous = timers.get(root);
    if (previous) clearTimeout(previous);

    const seeded = seedFirstImage(root);
    const images = [...root.querySelectorAll('[data-lite-image-a], [data-lite-image-b]')];
    const ready = images.some((image) => image.complete && image.naturalWidth > 0);

    if (seeded || ready) settle(root);

    images.forEach((image) => {
      if (image.dataset.msqLoadGuardReady === '1') return;
      image.dataset.msqLoadGuardReady = '1';
      image.addEventListener('load', () => hide(root));
      image.addEventListener('error', () => hide(root));
    });

    timers.set(root, setTimeout(() => hide(root), 3000));
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-oem-lite]').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('oem-lite:change', (event) => {
    const root = event.target.closest?.('[data-oem-lite]');
    if (!root) return;
    arm(root);
    settle(root);
  });

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
